import clsx, { type ClassValue } from 'clsx';

/**
 * Utility function to merge class names
 * Combines clsx with Tailwind CSS class merging
 */
export const cn = (...inputs: ClassValue[]) => {
  return clsx(inputs);
};
